import { SubAPI } from "./SubAPI";
export class LogiCtrl extends SubAPI {
    listStatuses(input) { return this.fetcher.get("/api/logictrl/statuses", input); }
    listRules(input) { return this.fetcher.get("/api/logictrl/rules", input); }
    listHwRuleSummary(input) { return this.fetcher.post("/api/logictrl/get-hw-rule-summary", input); }
    listHwStatusSummary(input) { return this.fetcher.post("/api/logictrl/get-hw-status-summary", input); }
    upsertRules(input) { return this.fetcher.post("/api/logictrl/rules", input); }
    upsertHwRules(input) { return this.fetcher.post("/api/logictrl/hw-rules", input); }
    bulkUpsertRules(input) { return this.fetcher.post("/api/logictrl/bulk-opening-rules", input); }
    listExisting(input) { return this.fetcher.get("/api/logictrl/existing", input); }
    upsertExisting(input) { return this.fetcher.post("/api/logictrl/existing", input); }
    applyExisting(input) { return this.fetcher.post("/api/logictrl/existing/apply", input); }
    applyBulkChange(input) { return this.fetcher.post("/api/logictrl/existing/apply-bulk", input); }
    setPoModifyApproval(input) { return this.fetcher.post("/api/logictrl/existing/po-modify", input); }
    listChanges(input) { return this.fetcher.get("/api/logictrl/changes/groupped", input); }
    listPendingChanges(input) { return this.fetcher.get("/api/logictrl/changes", input); }
    upsertPrice(input) { return this.fetcher.post("/api/logictrl/change", input); }
    listWorkOrders(input) { return this.fetcher.get("/api/logictrl/work-orders", input); }
    upsertWorkOrder(input) { return this.fetcher.post("/api/logictrl/work-order", input); }
}
